export default __webpack_public_path__ + "static/kooledge-7fa176fd6e66aa919c45282baacf0204.svg";